import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "payment-conditions" }

import { Component, computed, ComputedRef } from 'vue'

  // Types
  import {
    OptionSummary,
    PaymentCondition,
  } from '@/services/BookingService.interface'

  // Components
  import FixedPaymentCondition from './FixedPaymentCondition.vue'
  import FlexiblePaymentCondition from './FlexiblePaymentCondition.vue'

  // Config
  import { PrestType } from '@/config'

  // Props
  interface Props {
    options: OptionSummary[]
    liheId: number
    liheName?: string
    packageCode?: string
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'PaymentConditionsList',
  props: {
    options: {},
    liheId: {},
    liheName: {},
    packageCode: {}
  },
  setup(__props: any) {

  // Vue
  const props = __props

  // Filter accommodations that have valid payment conditions
  const accommodationsWithPaymentConditions: ComputedRef<OptionSummary[]> = computed(() => {
    if (!props.options) throw new Error('No accommodations in computed')

    // Filter by option type to get accommodations
    const accommodations = props.options.filter(
      (option: OptionSummary) => option.prestTypeId === PrestType.Accomodation
    )

    // Filter out accommodations without valid payment conditions and log warnings
    const validAccommodations = accommodations.filter((option: OptionSummary) => {
      if (option.paymentCondition === null || option.paymentCondition === undefined) {
        console.warn(`Accommodation ${option.prestId} (${option.name}) has null/undefined payment condition. Skipping payment condition display.`)
        return false
      }
      
      if (option.paymentCondition !== PaymentCondition.FIXED && option.paymentCondition !== PaymentCondition.FLEXIBLE) {
        console.warn(`Accommodation ${option.prestId} (${option.name}) has invalid payment condition: ${option.paymentCondition}. Expected ${PaymentCondition.FIXED} (FIXED) or ${PaymentCondition.FLEXIBLE} (FLEXIBLE).`)
        return false
      }
      
      return true
    })

    return validAccommodations
  })

  // Methods
  const getPaymentComponent = (
    paymentCondition: PaymentCondition
  ): Component => {
    if (paymentCondition === PaymentCondition.FIXED) {
      return FixedPaymentCondition
    } else if (paymentCondition === PaymentCondition.FLEXIBLE) {
      return FlexiblePaymentCondition
    } else {
      // This should not happen due to our filtering, but provide fallback
      return FlexiblePaymentCondition
    }
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accommodationsWithPaymentConditions.value, (option, index) => {
      return (_openBlock(), _createBlock(_resolveDynamicComponent(getPaymentComponent(option.paymentCondition as PaymentCondition)), {
        key: `${option.prestId}-${index}`,
        prestId: option.prestId,
        "cancellation-until": option.cancellationUntil,
        "lihe-id": props.liheId,
        "lihe-name": props.liheName,
        "package-code": props.packageCode,
        class: "mb-2"
      }, null, 8, ["prestId", "cancellation-until", "lihe-id", "lihe-name", "package-code"]))
    }), 128))
  ]))
}
}

})